import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { authFetch, isAuthenticated } from "../api";

// Guards the admin panel. Being signed in is not enough: marketplace buyers / sellers have accounts
// too, so the server must confirm the account is staff (their own API calls are refused regardless).
export default function ProtectedRoute({ children }) {
  const [state, setState] = useState(isAuthenticated() ? "checking" : "anonymous"); // checking | staff | member | anonymous

  useEffect(() => {
    if (!isAuthenticated()) {
      setState("anonymous");
      return;
    }
    let cancelled = false;
    authFetch("/core/profile/")
      .then((res) => (res.ok ? res.json() : null))
      .then((profile) => { if (!cancelled) setState(profile ? (profile.is_staff ? "staff" : "member") : "anonymous"); })
      .catch(() => { if (!cancelled) setState("anonymous"); });
    return () => { cancelled = true; };
  }, []);

  if (state === "checking") return null;
  if (state === "anonymous") return <Navigate to="/login" replace />;
  if (state === "member") return <Navigate to="/co-work/dashboard" replace />;
  return children;
}
